import Icon from '@/components/ui/AppIcon';

interface CareerPathCardProps {
  path: {
    title: string;
    description: string;
    icon: string;
    programs: number;
    avgSalary: string;
    jobOpenings: string;
  };
}

export default function CareerPathCard({ path }: CareerPathCardProps) {
  return (
    <div className="bg-card rounded-xl shadow-sky-sm hover:shadow-sky-md transition-all duration-300 p-6 border border-border group">
      <div className="flex items-start gap-4 mb-4">
        <div className="p-3 bg-gradient-to-br from-primary/10 to-accent/10 rounded-lg group-hover:scale-110 transition-transform duration-300">
          <Icon name={path.icon as any} size={28} variant="outline" className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-headline font-bold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
            {path.title}
          </h3>
          <p className="text-sm font-body text-muted-foreground line-clamp-2">{path.description}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border">
        <div>
          <p className="text-xs font-body text-muted-foreground mb-1">Avg Salary</p>
          <p className="text-lg font-headline font-bold text-primary">{path.avgSalary}</p>
        </div>
        <div>
          <p className="text-xs font-body text-muted-foreground mb-1">Job Openings</p>
          <p className="text-lg font-headline font-bold text-success">{path.jobOpenings}</p>
        </div>
      </div>
    </div>
  );
}